import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Audit } from 'app/core/models/audit.model';
import { Office } from 'app/core/models/office.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { OfficeService, PagedOfficeAudits } from 'app/core/services/office.service';

import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { AuditOfficeCreateRowComponent } from '../../components/audit-office-create-row/audit-office-create-row.component';
import { AuditOfficeUpdateRowComponent } from '../../components/audit-office-update-row/audit-office-update-row.component';
import { AuditNoteCreateRowComponent } from '../../components/audit-note-create-row/audit-note-create-row.component';
import { AuditProviderOfficeCreateRowComponent } from '../../components/audit-provider-office-create-row/audit-provider-office-create-row.component';
import { AuditProviderOfficeUpdateRowComponent } from '../../components/audit-provider-office-update-row/audit-provider-office-update-row.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-office-audit',
    templateUrl: './capture-admin-office-audit.component.html',
    styleUrls: ['./capture-admin-office-audit.component.scss'],
    imports: [PaginationHeaderComponent,
              AuditOfficeCreateRowComponent,
              AuditOfficeUpdateRowComponent,
              AuditNoteCreateRowComponent,
              AuditProviderOfficeCreateRowComponent,
              AuditProviderOfficeUpdateRowComponent,
              PaginationComponent,
              MatProgressSpinner]
})
export class CaptureAdminOfficeAuditComponent implements OnInit {
  private officeService = inject(OfficeService);
  private route = inject(ActivatedRoute);

  office: Office;
  audits: Audit[];

  loadingOffice: boolean;
  loadingAudits: boolean;

  paging: LimitOffsetPaging;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.init();
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadAudits(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadAudits(page);
  }

  private init() {
    const id = this.route.snapshot.paramMap.get('id');
    this.loadingOffice = true;
    this.officeService.get(id).subscribe(office => {
      this.office = office;
      this.loadingOffice = false;
      this.loadAudits(this.paging.currentPage);
    });
  }

  private loadAudits(page: number) {
    const paging = { page, pageSize: this.paging.pageSize };

    this.loadingAudits = true;

    this.officeService.getAudits(this.office, paging).subscribe((result: PagedOfficeAudits) => {
      this.audits = result.records;
      this.paging = result.meta.paging;
      this.loadingAudits = false
    })
  }
}
